import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Quotation,
    QuotationHistorical,
} from '../../../../../shared/types/modules/quotation';
import { ACCOUNTS } from '../../../../../routes/paths';
import {
    asyncGetQuotation,
    asyncGetQuotationHistorical,
} from '../../../../../services/quotation.service';

export const useQuotationDetail = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idQuotation } = useParams();
    const [loading, setLoading] = useState(false);
    const [quotation, setCaseGenerals] = useState<Quotation>();
    const [quotationHistorical, setQuotationHistorical] =
        useState<QuotationHistorical[]>();

    useEffect(() => {
        if (Boolean(idQuotation?.trim())) {
            setLoading(true);
            asyncGetQuotation(idQuotation?.trim())
                .then((quotation) => {
                    if (quotation) setCaseGenerals(quotation);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idQuotation]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetQuotationHistorical(idQuotation)
                .then((resp) => {
                    if (resp) setQuotationHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return { loading, quotation, quotationHistorical };
};
